import React, { useId } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { styles as ui } from "stories/Admin";
import styles from "./DateField.module.scss";

interface DateFieldProps {
  label: string;
  required?: boolean;
  selected: Date | null;
  onChange: (date: Date | null) => void;
  dateFormat?: string;
  placeholder?: string;
}

/** react-datepicker with the admin field look. */
const DateField: React.FC<DateFieldProps> = ({
  label,
  required,
  selected,
  onChange,
  dateFormat = "dd.MM.yyyy",
  placeholder = "dd.mm.åååå",
}) => {
  const id = useId();
  return (
    <div className={`${ui.fld} ${styles.dateField}`}>
      <label className={ui.lbl} htmlFor={id}>
        {label}
        {required && <span className={ui.req}> *</span>}
      </label>
      <DatePicker
        id={id}
        selected={selected}
        onChange={(date) => onChange(date)}
        dateFormat={dateFormat}
        placeholderText={placeholder}
        className={ui.inp}
        autoComplete="off"
      />
    </div>
  );
};

export default DateField;
